import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import * as Scroll from 'react-scroll';

// Helper
import i18n from '../../lib/reacti18n';
import { trackLink, dataMasking } from '../../lib/analytics-helper';

// Scroll
const scroll = Scroll.animateScroll;

// Data for Feedback
const feedback = {
  header: i18n.message('smarthelp/feedback.feedback.header'),
  select: {
    yes: i18n.message('smarthelp/feedback.feedback.select.yes'),
    no: i18n.message('smarthelp/feedback.feedback.select.no'),
    send: i18n.message('smarthelp/feedback.feedback.select.send'),
  },
  success: i18n.message('smarthelp/feedback.feedback.greeting.success'),
};

const freeform = {
  header: i18n.message('smarthelp/feedback.feedback.freeform.header'),
  placeholder: i18n.message('smarthelp/feedback.feedback.freeform.placeholder'),
  limit: i18n.message('smarthelp/feedback.feedback.freeform.limit'),
  options: {
    toomuchinfo: i18n.message('smarthelp/feedback.feedback.freeform.options.toomuchinfo'),
    notenoughinfo: i18n.message('smarthelp/feedback.feedback.freeform.options.notenoughinfo'),
    lookingfor: i18n.message('smarthelp/feedback.feedback.freeform.options.lookingfor'),
    incorrect: i18n.message('smarthelp/feedback.feedback.freeform.options.incorrect'),
    dontlike: i18n.message('smarthelp/feedback.feedback.freeform.options.dontlike'),
    other: i18n.message('smarthelp/feedback.feedback.freeform.options.other'),
  },
  row: 3,
  maxLength: 100,
};

const freeformFPTI = {
  Yes: 'Y',
  toomuchinfo: 'N1',
  notenoughinfo: 'N2',
  lookingfor: 'N3',
  incorrect: 'N4',
  dontlike: 'N5',
  other: 'N99',
};

const freeformFlag = 'free-form'; // free form css class notifier
const freeformHeight = 200;
const freeformWithTextAreaHeight = 350;
const inputMaxLength = 100;

class FAQFeedback extends Component {
  // Render feedback send successfully
  static renderGreetingSuccess() {
    return (
      <div className="feedback-greeting-success">
        {feedback.success}
      </div>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      submit: false,
      expSubmit: {
        personal: false,
        business: false,
      },
      displayFreeform: false,
      feedbackBox: false,
      selected: '',
      formValue: '',
    };

    this.submitFeedback = this.submitFeedback.bind(this);
    this.toggleFreeform = this.toggleFreeform.bind(this);
    this.closeFreeform = this.closeFreeform.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
  }

  // return freeform option CSS class
  getFreeformOptionClass(key) {
    return classNames({
      'free-form-option': true,
      'option-seleted': key === this.state.selected,
    });
  }

  // Get User experience by content toggle and url
  getCurrentExp() {
    // TODO: add no content toggle logic in this function
    if (this.props.contactSwitch) {
      return this.props.contactSwitch;
    }
    return this.props.exp;
  }

  // click free Form selection
  clickFreeForm(key) {
    this.setState({
      selected: key,
      feedbackBox: true,
    });

    setTimeout(() => {
      // Set focus to text area in the freeform
      if (this.textarea) {
        this.textarea.focus();
      }
    }, 50);
  }

  // Render Free Form text field
  textField(key) {
    if (key === this.state.selected) {
      return (
        <div className={`${freeformFlag}-field`}>
          <textArea
            id={`${freeformFlag}-textarea`}
            type="text"
            value={this.state.formValue}
            onChange={this.handleFormChange}
            className={`${freeformFlag}-textarea`}
            rows={freeform.row}
            maxLength={freeform.maxLength}
            placeholder={freeform.placeholder}
            ref={(input) => { this.textarea = input; }}
          />
          <div className={`${freeformFlag}-limit`}>{freeform.limit}</div>
          <button className={`vx_btn vx_btn-small ${freeformFlag}-send`} onClick={this.submitFeedback} value={key}>{feedback.select.send}</button>
        </div>
      );
    }
    return null;
  }

  // Handle user press enter key event
  handleKeyPress(event, key) {
    if (event.which === 13) {
      this.clickFreeForm(key);
    }
  }

  // Handle freeform change
  handleFormChange(event) {
    // Set Max length for textarea
    const formValue = event.target.value ? event.target.value.substr(0, inputMaxLength) : '';
    this.setState({
      formValue,
    });
  }

  // Auto Scroll for freeform
  scrollFreeformUp() {
    if (this.noButton) {
      const bottomPosition = this.noButton.getBoundingClientRect().bottom;
      const clientHeight = document.body.clientHeight;
      const diff = clientHeight - bottomPosition;

      // Scroll Up if the freeform can not show completely
      if (!this.state.displayFreeform && diff < freeformHeight) {
        const options = {
          duration: 500,
          smooth: true,
        };

        // Check whether the freeform textarea is open or not
        if (this.state.feedbackBox) {
          scroll.scrollMore(freeformWithTextAreaHeight - diff, options);
        } else {
          scroll.scrollMore(freeformHeight - diff, options);
        }
      }
    }
  }

  // Handle click event for 'No' button
  toggleFreeform(event) {
    event.preventDefault();
    this.setState({
      displayFreeform: !this.state.displayFreeform,
      formValue: '',
    });
    document.addEventListener('click', this.closeFreeform);

    this.scrollFreeformUp();
  }

  // close free form if user click outside of freeform
  closeFreeform(event) {
    const targetClass = event.target.className;
    if (targetClass && !targetClass.includes(freeformFlag)) {
      this.setState({
        displayFreeform: false,
      });
      document.removeEventListener('click', this.closeFreeform);
    }
  }

  // Update the hcaf and hcar for feedback FPTI
  submitFPTI(option) {
    if (_.has(freeformFPTI, option) && this.props.articleId) {
      const hcar = freeformFPTI[option];
      let hcaf = `${this.props.articleId}|${hcar}`;

      // Add User experience for fpti
      const userExp = this.getCurrentExp();
      if (userExp) {
        hcaf += `|${userExp}`;
      }

      if (hcar !== 'Y' && this.state.formValue) {
        // Data masking textform data
        hcaf += `|${dataMasking(this.state.formValue)}`;
      }

      trackLink({ id: 'articlePage', link: `${this.props.FPTILink}|feedback`, feedback: { hcar, hcaf } });
    }
  }

  // Submit Feedback by update FPTI
  submitFeedback(event) {
    event.preventDefault();

    // Check the user experience
    const userExp = this.getCurrentExp();
    if (userExp) {
      const submitState = this.state.expSubmit;
      submitState[userExp] = true;
      this.setState({
        expSubmit: submitState,
      });
    } else {
      this.setState({
        submit: true,
      });
    }

    this.submitFPTI(event.target.value);
  }

  renderFreeFormOption(options, key) {
    return (
      <li className={`${freeformFlag}-panel`} key={key}>
        <div // eslint-disable-line jsx-a11y/no-static-element-interactions
          value={key}
          className={this.getFreeformOptionClass(key)}
          role="button"
          tabIndex="0"
          onClick={() => this.clickFreeForm(key)}
          onKeyPress={event => this.handleKeyPress(event, key)}
        >
          {options[key]}
        </div>
        {this.textField(key)}
      </li>
    );
  }

  // Render Freeform clickable Options
  renderOptions() {
    const options = freeform.options;
    const keys = _.keys(options);
    if (keys.length > 0) {
      return keys.map(key => this.renderFreeFormOption(options, key));
    }
    return null;
  }

  // Render freeform after click 'no'
  renderFreeForm() {
    if (!this.state.displayFreeform) {
      return null;
    }
    return (
      <div className={`feedback-${freeformFlag}`} >
        <div className={`${freeformFlag}-header`}>{freeform.header}</div>
        <ul className={`${freeformFlag}-body`}>
          {this.renderOptions()}
        </ul>
      </div>
    );
  }

  // Render Yes/No and freeform
  renderSelection() {
    return (
      <form className="feedback-content">
        <div className="feedback-heading">{feedback.header}</div>
        <div className="feedback-body-controls">
          <button className="feedback-button feedback-button-yes" onClick={this.submitFeedback} value={feedback.select.yes}>{feedback.select.yes}</button>
          <button className="feedback-button feedback-button-no" ref={(click) => { this.noButton = click; }} onClick={this.toggleFreeform}>{feedback.select.no}</button>
          {this.renderFreeForm()}
        </div>
      </form>
    );
  }

  renderContent() {
    const userExp = this.getCurrentExp();
    if (userExp) {
      return this.state.expSubmit[userExp] ? FAQFeedback.renderGreetingSuccess() : this.renderSelection();
    }
    return this.state.submit ? FAQFeedback.renderGreetingSuccess() : this.renderSelection();
  }

  render() {
    return (
      <div className="feedback-container">
        {this.renderContent()}
      </div>
    );
  }
}

FAQFeedback.propTypes = {
  FPTILink: PropTypes.string,
  articleId: PropTypes.string,
  exp: PropTypes.string,
  contactSwitch: PropTypes.string,
};

FAQFeedback.defaultProps = {
  FPTILink: '',
  articleId: '',
  exp: '',
  contactSwitch: '',
};

export default FAQFeedback;



// WEBPACK FOOTER //
// ./home/components/FAQFeedback.js